import Axios from "axios";
import Swal from "sweetalert2";

export default (store = {}) => {
  Axios.defaults.baseURL = "https://api.ardunic.com/v1";
  Axios.interceptors.request.use((req) => {
    // if (store.getters) {
    //   if (store.getters.getToken)
    //     req.headers.access_token = localStorage.getItem('token');
    // }
    return req;
  });
  Axios.interceptors.response.use(
    (res) => res,
    (err) => {
      Swal.fire({
        title: "Whoops 😟",
        text: err.response.data
          ? err.response.data.message
          : "Something Went Wrong",
        toast: true,
        timer: 2000,
        icon: "error",
        position: "top-right",
      });
      throw err;
    }
  );
  return Axios;
};
